import { data } from '@amazon/vinyl-observable'

export const modalCount = data(0)
export const modalVisible = modalCount.map((v) => !!v)
export const modalVisibleClass$ = modalVisible.map((v) => (v ? 'modalVisible' : null))
